
import Vue from 'vue'
export default Vue.extend({
  name: 'AnchorMenu',
  props: {
    links: {
      required: true
    },
    respectScrollMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMobile: function () {
      if (window.innerWidth < 992) {
        return true
      }
      return false
    }
  },
  methods: {
    scrollTo (link) {
      const element = document.querySelector(link);
      if (!element) return;
      if (this.respectScrollMargin) {
        // The ODIN route resolves deferred content before positioning its anchor.
        this.$emit('navigate', link);
        return;
      }
      const yOffset = this.isMobile ? -60 : -80;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({top: y, behavior: reduceMotion ? 'auto' : 'smooth'});
    }
  }
})
